<template>
  <AppShell>
    <router-view />
  </AppShell>
</template>

<script setup>
import AppShell from './AppShell.vue'
</script> 